import React from 'react';
import Page from '../Containers/Page';

export default class NotFoundPage extends React.Component {
    render() {
        return <Page hideFooter={true} title="Страницата не съществува">
            <div className="not-found-container">
                <div className="not-found-cloud">404</div>
                <h3 className="text-404">Страницата не може да бъде намерена.</h3>
            </div>
        </Page>
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/NotFoundPage.js